import { useMutation as e } from "@tanstack/react-query";
import { ag as n } from "./services.gen-72h9jWK3.js";
function s(t) {
  return {
    ...e({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (o) => n(o),
      ...t
    })
  };
}
export {
  s as u
};
//# sourceMappingURL=useCreateConversationReview-CX3jha91.js.map
